import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WindowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"window"}/>
}
